<template>
  <section class="modify-reservation component">
    <transition name="fade">
      <router-view />
    </transition>
    <modify-logout-modal />
  </section>
</template>
<script>
  import { mapActions } from 'vuex'
  import modifyLogoutModal from './modify-reservation-logout/modify-reservation-logout-modal.vue'

  export default {
    name: 'ModifyReservationMain',
    components: {
      modifyLogoutModal,
    },
    provide() {
      return {
        bookingUrl: this.bookingUrl,
        currencies: this.currencies,
        modifyAddOnsData: this.modifyAddOnsData,
      }
    },
    props: {
      /**
       * URl to redirect the user to after criteria selection
       */
      bookingUrl: {
        type: String,
      },
      /**
       * Set of translated labels to be registered in the [i18n store module](/docs/api/store/i18n)
       */
      lang: {
        required: true,
        type: Object,
        default: () => ({}),
      },
      currencies: {
        type: Array,
        default: () => []
      },
      modifyBookingData: {
        required: true,
        type: Object,
        default: () => ({}),
      },
      modifyAddOnsData: {
        required: true,
        type: Object,
        default: () => ({}),
      },
    },
    async created() {
      await this.registerLang({ scope: 'booking', lang: this.lang })
      await this.registerModifyBookingPropData(this.modifyBookingData)
      this.updatedSelectedReservations([])
      this.redirectReservationDetails()
    },
    methods: {
      ...mapActions('i18n', ['registerLang']),
      ...mapActions('modifyReservation', [
        'registerModifyBookingPropData',
        'updatedSelectedReservations',
        'readReservation',
      ]),
      async redirectReservationDetails() {
        // if url comes from dashboard modify button - checks for params on curent url
        const queryParams = new URLSearchParams(window.location.search)
        const resLookUpNumber = queryParams.get('LookUpNumber')
        let resEmail = queryParams.get('email')
        if (resEmail && resLookUpNumber) {
          resEmail = resEmail.replace(/ /g, '+')
          window.dispatchEvent(new Event('redirectLoading')) // hides the lookup form on redirect
          sessionStorage.setItem('storedReservationMyStaysEntry', true)
          const payload = {
            LookUpNumber: resLookUpNumber,
            Email: resEmail,
          }
          const data = await this.readReservation({ lookUpDataObject: payload })
          if (data.reservations) {
            this.$router.push({ name: 'modify-reservation-detail' })
          }

          this.cleanRedirectReservationUrl()
        }
      },
      cleanRedirectReservationUrl() {
        const url = new URL(window.location.href)
        url.searchParams.delete('LookUpNumber')
        url.searchParams.delete('email')

        const cleanUrl = `${url.origin}${url.pathname}${url.hash}`
        // Update the browser's URL history without refreshing the page
        window.history.pushState({ path: cleanUrl }, '', cleanUrl)
      },
    },
  }
</script>
